<template>
  <div
    v-if="current != before"
    :class="{
      'success--text': current > before,
      'error--text': current < before
    }"
  >
    <v-icon :color="current > before ? 'success' : 'error'" x-small>
      {{ current > before ? "mdi-arrow-up-bold" : "mdi-arrow-down-bold" }}
    </v-icon>
    {{ getGrowthPercent() }} %
  </div>
  <div v-else>-</div>
</template>

<script>
export default {
  props: {
    current: { required: true, default: 0 },
    before: { required: true, default: 0 }
  },
  data: () => ({}),
  computed: {},
  methods: {
    getGrowthPercent() {
      if (this.current > 0 || this.before > 0) {
        return round(((this.current - this.before) / (this.before || 1)) * 100);
      }
      return 0;
    }
  }
};
function round(num) {
  var m = Number((Math.abs(num) * 100).toPrecision(15));
  return (Math.round(m) / 100) * Math.sign(num);
}
</script>

<style scoped>
</style>
